import { Button } from "@vlab-corporation/design-system";
import { isDemoMode, setDemoMode } from "./demoMode";
import { resetDemoStore, clearDemoStore } from "./demoStore";

export function DemoBanner() {
  if (!isDemoMode()) return null;

  function handleReset() {
    resetDemoStore();
    window.location.reload();
  }

  function handleExit() {
    clearDemoStore();
    setDemoMode(false);
    window.location.href = "/login";
  }

  return (
    <>
      {/* Top banner */}
      <div className="bg-amber-500 text-white text-center py-1.5 px-4 text-sm font-medium flex items-center justify-center gap-3">
        <span>데모 모드로 체험 중입니다. 실제 데이터에는 영향을 주지 않습니다.</span>
        <Button
          variant="ghost"
          onClick={handleReset}
          className="!text-white !text-xs underline !py-0 !px-1"
        >
          초기화
        </Button>
        <Button
          variant="ghost"
          onClick={handleExit}
          className="!text-white !text-xs underline !py-0 !px-1"
        >
          종료
        </Button>
      </div>

      {/* Watermark */}
      <div className="pointer-events-none fixed inset-0 z-50 flex items-center justify-center overflow-hidden">
        <span className="text-6xl font-bold text-gray-300/20 rotate-[-30deg] select-none whitespace-nowrap">
          DEMO
        </span>
      </div>
    </>
  );
}
